<template>

<div id="slide07" class="section section-light">

  <Subtitle :text="$t('home.slide07.title')"/>

  <div class="ul-div">

    <Ul
      section="slide07"
      :items="[
        $t('home.slide07.bullets.bullet01'),
        $t('home.slide07.bullets.bullet02'),
        $t('home.slide07.bullets.bullet03'),
        $t('home.slide07.bullets.bullet04'),
        $t('home.slide07.bullets.bullet05')
      ]"/>

  </div>

</div>

</template>

<script>
import Subtitle from '../general/texts/Subtitle.vue'
import Ul from '../general/elements/Ul.vue'

export default {
  name: 'Slide07',
  components: {
    Subtitle,
    Ul
  }
}
</script>

<style lang="scss" scoped>
.ul-div {
  font-size: 18px;
}

::v-deep li {
  margin: 30px 0 !important;
}
</style>
